
import Base from "./Base"
class EditBase extends Base {

    constructor(options) {
        super(options);
        options = options || {};
        this.drawBase = options.drawBase; //绘制者
        this.plot = options.plot; //当前标绘
        this.editGuid = this.guid(); //唯一标识
        this.entities = []; //脏数据
        this.pickPos = undefined;//关键点
        this.centerPos = undefined;//中心点
        this.rotationPos = undefined;//旋转点
        this.heightPos = undefined;//抬升点
        this.positionMove = undefined;// 鼠标拖到位置
        this.editing = false; //编辑状态
        this.activeEditEvent = new Cesium.Event();
        this.hasHeight = options.hasHeight == false ? false : true; //是否可以抬升
    }

    activeEditEventOn(callback) {
        this.activeEditEvent.addEventListener(callback, this);
    }

    getType() {
        return "edit_Base"
    }
    start(auto = true) {

        console.log("111111")

        if (this.isStarted) {
            return;
        }

        var $this = this;
        this.handler = new this.Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);

        this.handler.setInputAction((e) => $this.leftClick(e), $this.Cesium.ScreenSpaceEventType.LEFT_CLICK);
        this.handler.setInputAction((e) => $this.leftDown(e), $this.Cesium.ScreenSpaceEventType.LEFT_DOWN);
        this.handler.setInputAction((e) => $this.mouseMove(e), $this.Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        this.handler.setInputAction((e) => $this.leftUp(e), $this.Cesium.ScreenSpaceEventType.LEFT_UP);
        this.isStarted = true;
        if (auto) {
            this.activeEditEvent.raiseEvent(this.plot);
        }
    }


    checkKeyPoint() {
        return true;
    }
    checkCenterPoint() {
        return true;
    }
    checkRotatePoint() {
        return true;
    }
    checkHeightPoint() {
        return true;
    }
    initProperty(bool) {

    }
    initAttrPlot(plot) {
        this.plot = plot; //当前标绘
        this.initExtID();
        this.initKeyPoint();
        this.initCenterPoint();
        this.initRotatePoint();
        this.initHeightPoint();
    }


    //初始化扩展ID
    initExtID() {
        this.plot.attrPlot = this.plot.attrPlot || {};
        this.plot.attrPlot["editGuid"] = this.editGuid;
    }
    //初始化关键点-edit_keyPos
    initKeyPoint() {
        if (!this.checkKeyPoint()) {
            return;
        }
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var e_pos = [];
        for (let i = 0; i < keyPos.length; i++) {
            var entity = this.createEnity();
            var point = this.createPoint(this.getDefaultStyle("point_Nor"));
            entity.show = false;
            entity.position = keyPos[i];
            entity.point = point;
            this.viewer.entities.add(entity);
            this.entities.push(entity);
            entity.attrPlot = {
                e_index: i,
                editGuid: this.editGuid,
                edit_keyFlag: true
            };
            e_pos.push(entity);
        }
        this.plot.attrPlot["edit_keyPos"] = e_pos; //实体
    }

    //初始化中心点-edit_center
    initCenterPoint() {
        if (!this.checkCenterPoint()) {
            return;
        }
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        if (keyPos.length >= 2) {
            var posArr = this.cart2Wgs84(keyPos);
            var center = this.getCenter(posArr);
            var carto = Cesium.Cartographic.fromDegrees(center[0], center[1]);
            var heightTerrain = this.viewer.scene.globe.getHeight(carto);
            var cartesian3 = Cesium.Cartesian3.fromDegrees(center[0], center[1], heightTerrain);
            var entity = this.createEnity();
            var point = this.createPoint(this.getDefaultStyle("point_Center"));
            entity.show = false;
            entity.position = cartesian3;
            entity.point = point;
            entity.attrPlot = {
                editGuid: this.editGuid,
                edit_centerFlag: true
            };
            this.viewer.entities.add(entity);
            this.entities.push(entity);
            this.plot.attrPlot["edit_center"] = entity; //实体
            this.plot.attrPlot['center_cartesian3'] = cartesian3;
        }
    }

    //初始化旋转点-edit_rotation
    initRotatePoint() {
        if (!this.checkRotatePoint()) {
            return;
        }
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        if (keyPos.length <= 1) {
            return;
        }

        var rectangle = this.getRectangle(keyPos);
        var width = Cesium.Cartesian3.distance(rectangle[0], rectangle[1]);
        var cartesian3 = this.getPositionTranslation(rectangle[1], { x: width / 8, y: width / 8, z: 0 });

        var entity = this.createEnity();
        var point = this.createPoint(this.getDefaultStyle("point_Rotate"));
        entity.show = false;
        entity.position = cartesian3;
        entity.point = point;
        entity.attrPlot = {
            editGuid: this.editGuid,
            edit_rotationFlag: true
        };
        this.viewer.entities.add(entity);
        this.entities.push(entity);
        this.plot.attrPlot["edit_rotation"] = entity; //实体
        this.plot.attrPlot["rotation_cartesian3"] = cartesian3; //实体
    }

    initHeightPoint() {

        if (!this.hasHeight || !this.checkHeightPoint()) {
            return;
        }

        var entity = this.plot.attrPlot["edit_center"]; //实体
        var position = entity.position.getValue();

        var carto = Cesium.Cartographic.fromCartesian(position);
        var heightTerrain = this.viewer.scene.globe.getHeight(carto);

        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var rectangle = this.getRectangle(keyPos);
        var width = Cesium.Cartesian3.distance(rectangle[0], rectangle[1]);
        var offest = width / 8;
        var heightAll = heightTerrain + offest
        if (this.plot.polygon && this.plot.polygon.attr && this.plot.polygon.attr.extrudedHeight) {
            heightAll = this.plot.polygon.attr.extrudedHeight;
        }

        var heightPos = this.getPositionTranslation(position, { x: 0, y: 0, z: heightAll });
        var entity = this.createEnity();
        var point = this.createPoint(this.getDefaultStyle("point_height"));
        entity.show = false;
        entity.position = heightPos;
        entity.point = point;
        entity.attrPlot = {
            editGuid: this.editGuid,
            edit_heightFlag: true
        };
        this.viewer.entities.add(entity);
        this.entities.push(entity);
        this.plot.attrPlot["edit_height"] = entity; //实体
        this.plot.attrPlot["height_cartesian3"] = heightPos; //
    }

    updatePlot() {

    }

    updateKey(cartesian, index) {
        if (!this.checkKeyPoint()) {
            return;
        }
        this.plot.attrPlot["edit_positions"].splice(index, 1, cartesian);
    }

    //更新中心点
    updateCenter() {
        if (!this.checkCenterPoint()) {
            return;
        }
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var centerPos = this.plot.attrPlot["edit_center"];
        if (!centerPos || keyPos.length < 2) {
            return
        }
        var posArr = this.cart2Wgs84(keyPos);
        var center = this.getCenter(posArr);
        var carto = Cesium.Cartographic.fromDegrees(center[0], center[1]);
        var heightTerrain = this.viewer.scene.globe.getHeight(carto);
        var cartesian3 = Cesium.Cartesian3.fromDegrees(center[0], center[1], heightTerrain);
        centerPos.position.setValue(cartesian3); //更新坐标
        this.plot.attrPlot['center_cartesian3'] = cartesian3;
    }

    updateHeightPoint() {
        if (!this.hasHeight || !this.checkHeightPoint()) {
            return;
        }
        var entity = this.plot.attrPlot["edit_height"]; //实体
        var height = 0;

        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var rectangle = this.getRectangle(keyPos);
        var width = Cesium.Cartesian3.distance(rectangle[0], rectangle[1]);
        var offest = width / 8;
        if (this.plot.attrPlot["edit_extrudedHeight"]) {
            height = this.plot.attrPlot["edit_extrudedHeight"].getValue();
        }
        var center = this.plot.attrPlot['center_cartesian3'];
        var carto_center = Cesium.Cartographic.fromCartesian(center);
        var heightTerrain = this.viewer.scene.globe.getHeight(carto_center); //贴地高度
        height += heightTerrain;
        height += offest;
        var positionNew = Cesium.Cartesian3.fromRadians(carto_center.longitude, carto_center.latitude, height);
        entity.position.setValue(positionNew);
        this.plot.attrPlot["height_cartesian3"] = positionNew; //
    }

    //更新旋转点
    updateRotate() {
        if (!this.checkRotatePoint()) {
            return;
        }
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var rotationPos = this.plot.attrPlot["edit_rotation"];
        if (!rotationPos || keyPos.length <= 1) {
            return;
        }
        var rectangle = this.getRectangle(keyPos);
        var width = Cesium.Cartesian3.distance(rectangle[0], rectangle[1]);
        var cartesian3 = this.getPositionTranslation(rectangle[1], { x: width / 8, y: width / 8, z: 0 });

        rotationPos.position.setValue(cartesian3); //更新坐标
        this.plot.attrPlot["rotation_cartesian3"] = cartesian3; //实体
    }


    //关键点整体平移
    translateAll(position) {
        if (!this.positionMove) {
            this.positionMove = position;
        }
        //记录差值 
        var diff = Cesium.Cartesian3.subtract(position, this.positionMove, new Cesium.Cartesian3());
        this.positionMove = position;
        var $this = this;
        //移动关键点
        var positions = this.plot.attrPlot["edit_positions"];
        for (let i = 0; i < positions.length; i++) {
            var newPos = Cesium.Cartesian3.add(positions[i], diff, new Cesium.Cartesian3());
            positions[i] = newPos;
        }
        //移动实体
        var ext_keyPos = $this.plot.attrPlot["edit_keyPos"];
        for (let i = 0; i < ext_keyPos.length; i++) {
            var pos = ext_keyPos[i].position.getValue();
            var newPos = Cesium.Cartesian3.add(pos, diff, new Cesium.Cartesian3());
            ext_keyPos[i].position.setValue(newPos);
        }
    }

    //关键点整体旋转
    rotationAll(position) {
        var $this = this;
        var center = this.plot.attrPlot['center_cartesian3'];
        var PA = this.plot.attrPlot['startPoint'];
        var angle = this.getAngleCenterPointDir(center, PA, position);
        if (isNaN(angle)) {
            return;
        }
        let theta = angle * (180 / Math.PI);
        var newPos = this.getRotateCenterPoint(center, PA, theta);
        this.rotationPos.position.setValue(newPos); //更新旋转点
        var positions = this.plot.attrPlot["edit_positions"];
        var positions_copy = this.plot.attrPlot["edit_positions_copy"]
        for (let i = 0; i < positions_copy.length; i++) {
            var p = positions_copy[i];
            var newPos = this.getRotateCenterPoint(center, p, theta);
            positions[i] = newPos;
            $this.plot.attrPlot["edit_keyPos"][i].position.setValue(newPos);
        }
    }

    //鼠标像素
    heightMoveAll(endPosition, startPosition) {
        var $this = this;
        var zOffset = new Cesium.Cartesian3();
        //改变高度垂直拖动
        var dy = endPosition.y - startPosition.y;

        var position = $this.heightPos.position.getValue();
        //获取该点的投影面
        var tangentPlane = new Cesium.EllipsoidTangentPlane(position);
        var scratchBoundingSphere = new Cesium.BoundingSphere(); //包围球体
        scratchBoundingSphere.center = position;
        scratchBoundingSphere.radius = 1;

        //获取像素大小-米
        var metersPerPixel = $this.viewer.scene.frameState.camera.getPixelSize(scratchBoundingSphere, $this.viewer.scene.frameState.context.drawingBufferWidth, $this.viewer.scene.frameState.context.drawingBufferHeight);
        var heightDiff = -dy * metersPerPixel;

        Cesium.Cartesian3.multiplyByScalar(tangentPlane.zAxis, heightDiff, zOffset);
        var newPosition = Cesium.Cartesian3.clone(position);
        Cesium.Cartesian3.add(position, zOffset, newPosition);

        //更新开始
        var oldHeight = $this.plot.polygon.extrudedHeight || 0;
        $this.plot.polygon.extrudedHeight = oldHeight + heightDiff;

        if (oldHeight + heightDiff <= 0) {
            $this.plot.polygon.extrudedHeight = 0;
        }

        console.log(heightDiff);

        $this.heightPos.position.setValue(newPosition);
        $this.plot.attrPlot["edit_extrudedHeight"] = $this.plot.polygon.extrudedHeight;

    }

    //备份点
    cloneKeyPos() {
        var positions = this.plot.attrPlot["edit_positions"];
        let arr = [];
        for (let i = 0; i < positions.length; i++) {
            var posClone = Cesium.Cartesian3.clone(positions[i]);
            arr.push(posClone);
        }
        this.plot.attrPlot["edit_positions_copy"] = arr;
    }
    enableEdit() {
        this.editing = true;
        this.initProperty()
    }
    disableEdit() {
        this.editing = false;
        this.initProperty()
    }
    showEdit() {
        var editPos = this.plot.attrPlot["edit_keyPos"];
        for (let i = 0; i < editPos.length; i++) {
            editPos[i].show = true
        }
        var ext_centerPos = this.plot.attrPlot["edit_center"];
        if (ext_centerPos) {
            ext_centerPos.show = true;
        }

        var ext_rotation = this.plot.attrPlot["edit_rotation"];
        if (ext_rotation) {
            ext_rotation.show = true;
        }

        var ext_height = this.plot.attrPlot["edit_height"];
        if (ext_height) {
            ext_height.show = true;
        }
    }

    hideEdit() {
        var editPos = this.plot.attrPlot["edit_keyPos"];
        for (let i = 0; i < editPos.length; i++) {
            editPos[i].show = false
        }
        var ext_centerPos = this.plot.attrPlot["edit_center"];
        if (ext_centerPos) {
            ext_centerPos.show = false;
        }

        var ext_rotation = this.plot.attrPlot["edit_rotation"];
        if (ext_rotation) {
            ext_rotation.show = false;
        }

        var ext_height = this.plot.attrPlot["edit_height"];
        if (ext_height) {
            ext_height.show = false;
        }
    }

    //停止编辑
    stop() {
        this.isStarted = false;// 编辑标识
        this.destroy();
        this.reset();
        this.unLockCamera();
    }

    destroy() {
        if (this.handler) {
            this.handler.destroy();
            this.handler = null;
        }
    }

    clear() {
        for (var i = 0; i < this.entities.length; i++) {
            this.viewer.entities.remove(this.entities[i]);
        }

        this.entities.length = 0;
    }

    reset() {
        this.pickPos = undefined;//关键点
        this.centerPos = undefined;//中心点
        this.rotationPos = undefined;//旋转点
        this.heightPos = undefined;//抬升点
        this.positionMove = undefined;// 鼠标拖到位置
    }

    leftClick(evt) {
        if (this.editing) {
           return;
        }
        this.hideEdit();
        let pick = this.viewer.scene.pick(evt.position);
        var entity = this.getPickEnity(pick);
        if (entity && entity.attrPlot && entity.attrPlot["editGuid"] == this.editGuid) {
            this.initProperty(false);//动态属性
            this.enableEdit();
            this.showEdit();
            this.activeEditEvent.raiseEvent(entity, evt);
            console.log(entity)
            this.editing=true;
        }
    }
    leftDown(evt) {
        this.reset(); //拾取开始
        let pick = this.viewer.scene.pick(evt.position);
        var entity = this.getPickEnity(pick);
        if (entity && entity.attrPlot && entity.attrPlot["edit_keyFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.pickPos = entity;
            this.lockCamera();//锁定相机
        }

        if (entity && entity.attrPlot && entity.attrPlot["edit_centerFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.centerPos = entity;
            this.lockCamera();//锁定相机
        }
        if (entity && entity.attrPlot && entity.attrPlot["edit_rotationFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.rotationPos = entity;
            this.plot.attrPlot['startPoint'] = entity.position.getValue();
            this.cloneKeyPos();
            this.lockCamera();//锁定相机
        }
        if (entity && entity.attrPlot && entity.attrPlot["edit_heightFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.heightPos = entity;
            this.lockCamera();//锁定相机
        }
    }

    //移动事件
    mouseMove(evt) {
        //关键点
        if (this.pickPos) {
            var cartesian = this.getCatesian3FromPX(evt.endPosition);
            this.pickPos.position.setValue(cartesian);
            var i = this.pickPos.attrPlot.e_index;
            this.updateKey(cartesian, i);
            this.updateCenter();
            this.updateRotate();
            this.updateHeightPoint();
            this.updatePlot();
        }

        //中心点
        if (this.centerPos) {
            var cartesian = this.getCatesian3FromPX(evt.endPosition);
            this.centerPos.position.setValue(cartesian);
            this.plot.attrPlot['center_cartesian3'] = cartesian;
            this.translateAll(cartesian);
            this.updateRotate();
            this.updateHeightPoint();
            this.updatePlot();
        }

        //旋转点
        if (this.rotationPos) {
            var cartesian = this.getCatesian3FromPX(evt.endPosition);
            this.rotationAll(cartesian);
            this.updatePlot();
        }

        //抬升点
        if (this.heightPos) {
            this.heightMoveAll(evt.endPosition, evt.startPosition);
        }
    }

    leftUp(evt) {
        if (this.heightPos){
            this.activeEditEvent.raiseEvent(this.plot, evt);
        }
        this.reset();
        this.unLockCamera();//解锁相机
        this.initProperty(true);//静态属性
        this.editing=false;
    }

}

export default EditBase;